<template>
    <div class="">
        <div class="top_title">
            <div class="top_back_home" @click="backToindex">
                <img src="../../../public/images/home.png" alt=""/>
                <p>返回首页</p>
            </div>
            <div class="title">
                批次管理
            </div>
        </div>
        <div class="main">
            <div class="top_title">
                <div class="left">
                    批次列表（{{ total }}）
                </div>
                <div class="right">
                    <div class="itt" @click="showBrokerList(1)">
                        <img src="../../../public/images/set.png" alt=""/>
                        <p>经济人管理</p>
                    </div>
                    <div class="itt" @click="productManagement">
                        <img src="../../../public/images/set.png" alt=""/>
                        <p>商品管理</p>
                    </div>
                    <div class="itt" @click="addPici(0)" style="margin-left: 10px;">
                        <img src="../../../public/images/add.png" alt=""/>
                        <p>新建批次</p>
                    </div>
                </div>
            </div>
            <div class="pici_list">
                <div class="pici_item" v-for="item in batchList">
                    <div class="pici_item_top">
                        <div class="left">
                            <div class="ll">
                                {{ item.batch_name }}
                            </div>
                            <div class="rr">
                                <span class="zd" v-if="item.is_top == 2">置顶</span>
                                <span class="yjs" v-if="item.is_settle == 2">已结算</span>
                            </div>
                        </div>
                        <div class="right">
                            <div class="itt zd_qx" v-if="item.is_settle == 1 && item.is_top == 2"
                                 @click="setTop(item.id)">
                                <img src="../../../public/images/zd_qx.png" alt=""/>
                                <p>取消置顶 </p>
                            </div>
                            <div class="itt zd" v-if="item.is_settle == 1 && item.is_top == 1" @click="setTop(item.id)">
                                <img src="../../../public/images/zd.png" alt=""/>
                                <p>置顶</p>
                            </div>

                            <div class="itt exit" v-if="item.is_settle == 1" @click="addPici(item.id)">
                                <img src="../../../public/images/exit_icon.png" alt=""/>
                                <p>编辑</p>
                            </div>

                            <div class="itt js" v-if="item.is_settle == 1" @click="startSettle(item)">
                                <img src="../../../public/images/js.png" alt=""/>
                                <p>结算</p>
                            </div>
                            <div class="itt js_look" v-if="item.is_settle == 2" @click="showSettleInfo(item.id)">
                                <img src="../../../public/images/js_look.png" alt=""/>
                                <p>查看结算</p>
                            </div>

                            <div class="itt del" @click="delBatch(item.id)">
                                <img src="../../../public/images/del_icon.png" alt=""/>
                                <p>删除</p>
                            </div>
                        </div>
                    </div>
                    <div class="pici_item_fei">
                        <div class="pici_item_fei_tit">
                            费用合计
                        </div>
                        <div class="pici_item_fei_box">
                            <div class="itt">
                                <p>运输费用</p>
                                <h3>¥{{ item.transport_fee }}</h3>
                            </div>
                            <div class="itt">
                                <p>手续费用</p>
                                <h3>¥{{ item.handle_fee }}</h3>
                            </div>
                            <div class="itt">
                                <p>其他费用</p>
                                <h3>¥{{ item.other_fee }}</h3>
                            </div>
                            <div class="itt">
                                <p>总成本</p>
                                <h3>¥{{ item.total_fee }}</h3>
                            </div>
                        </div>
                    </div>
                    <div class="pici_item_fei">
                        <div class="pici_item_fei_tit">
                            备注
                        </div>
                        <div class="pici_item_fei_box">
                            <div class="itt" style="font-size: 18px;">
                                <el-alert
                                    :title="item.remark"
                                    type="warning" :closable="false">
                                </el-alert>
                            </div>
                        </div>
                    </div>
                    <div class="zhedie">
                        <div class="zhedie_box slide-container" ref="slideContent">
                            <div class="zhedie_tit">
                                商品明细
                            </div>
                            <div class="zhedie_con">
                                <div class="zhedie_con_tit">
                                    <p>时间</p>
                                    <p>商品</p>
                                    <p>数量</p>
                                    <p>总重量</p>
                                    <p>单价</p>
                                    <p>总金额</p>
                                </div>
                                <div class="zhedie_con_body">
                                    <div class="itt" v-for="goods in item.batch_goods">
                                        <p>{{ goods.time }}</p>
                                        <p>{{ goods.name }}</p>
                                        <p>{{ goods.number }}只</p>
                                        <p>{{ goods.weight }}斤</p>
                                        <p>{{ goods.price }}元/斤</p>
                                        <p>{{ goods.total_price }}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- 加载状态指示器 -->
                <div class="loading-tips" v-if="isLoading">
                    <p>正在加载...</p>
                </div>
                <!-- 没有更多数据提示 -->
                <div class="no-more-tips" v-if="!hasMore && batchList.length > 0">
                    <p>没有更多数据了</p>
                </div>
            </div>
        </div>


        <!-- 新建批次弹窗 -->
        <div v-if="showDialogPici" class="dialog-overlay">
            <div class="dialog-content">
                <div class="dialog-header">
                    新建批次
                    <img @click="closeDialogPici" src="../../../public/images/close.png" alt=""/>
                </div>
                <div class="dialog-body">
                    <div style="height: 500px;overflow-y: scroll">
                        <el-row>
                            <el-col :span="3">
                                <div class="grid-title">
                                    <span style="color: #f40808">*</span>
                                    批次名称：
                                </div>
                            </el-col>
                            <el-col :span="21">
                                <!--                                <div class="grid-input">-->
                                <!--                                    <el-input size="small" v-model="batchForm.batch_name" clearable-->
                                <!--                                              placeholder="请输入批次名称，如:2026-第一批"></el-input>-->
                                <!--                                </div>-->
                                <el-form :inline="true" :model="batchForm" class="demo-form-inline">
                                    <div class="choose-box">
                                        <el-input class="choose-item" size="medium" style="width: 180px;" placeholder="请输入" v-model="batchForm.car_num">
                                            <template slot="append">车</template>
                                        </el-input>
                                        <el-select class="choose-item" size="medium" style="width: 120px;" v-model="batchForm.broker_id"
                                                   placeholder="经纪人">
                                            <el-option v-for="item in brokerList" :label="item.name" :value="item.id"></el-option>
                                        </el-select>
                                        <span style="font-size: 16px;margin-right: 10px;">拉</span>
                                        <el-input class="choose-item" size="medium" style="width: 180px;" placeholder="多少只" v-model="batchForm.only">
                                            <template slot="append">只</template>
                                        </el-input>
                                        <el-input class="choose-item" size="medium" style="width: 180px;" placeholder="金额" v-model="batchForm.money">
                                            <template slot="prepend">金额</template>
                                        </el-input>
                                    </div>
                                    <div class="choose-box">
                                        <div class="choose-item" size="medium">
                                            <el-date-picker
                                                v-model="batchForm.sell_date"
                                                type="date"
                                                format="MM-dd"
                                                value-format="MM-dd"
                                                :clearable="false"
                                                placeholder="选择日期">
                                            </el-date-picker>
                                        </div>
                                        <el-input class="choose-item" size="medium" style="width: 180px;" placeholder="已付" v-model="batchForm.paid">
                                            <template slot="prepend">已付</template>
                                        </el-input>
                                        <el-select class="choose-item" v-model="batchForm.is_settlement" placeholder="是否清账">
                                            <el-option label="未清账" value="1"></el-option>
                                            <el-option label="已清账" value="2"></el-option>
                                        </el-select>
                                    </div>
<!--                                    <div class="choose-box">-->
<!--                                        <el-form-item>-->
<!--                                            <el-button type="primary" @click="onSubmit">查询</el-button>-->
<!--                                        </el-form-item>-->
<!--                                    </div>-->
                                </el-form>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="2">
                                <div class="grid-title">
                                    商品选择
                                </div>
                            </el-col>
                            <el-col :span="21">
                                <div class="table">
                                    <el-table :data="tableDataProduct" current-row-key="">
                                        <el-table-column label="商品类型">
                                            <template slot-scope="scope">
                                                <el-select size="small" @change="changeSelectGoods(scope.$index)"
                                                           v-model="scope.row.goods_id" placeholder="请选择">
                                                    <el-option v-for="item in goodsList" :key="item.id"
                                                               :label="item.name"
                                                               :value="item.id">
                                                    </el-option>
                                                </el-select>
                                            </template>
                                        </el-table-column>
                                        <el-table-column label="数量（只）">
                                            <template slot-scope="scope">
                                                <el-input size="small" v-model="scope.row.number" placeholder="请输入"
                                                          type="number" style="width: 100px"></el-input>
                                            </template>
                                        </el-table-column>
                                        <el-table-column label="重量（斤）">
                                            <template slot-scope="scope">
                                                <el-input size="small" @change="changeGoodsWeigth(scope.$index)"
                                                          v-model="scope.row.weight" placeholder="请输入" type="number"
                                                          style="width: 100px"></el-input>
                                            </template>
                                        </el-table-column>
                                        <el-table-column label="单价（元/斤）">
                                            <template slot-scope="scope">
                                                <el-input size="small" @change="changeGoodsWeigth(scope.$index)"
                                                          v-model="scope.row.price" placeholder="请输入"
                                                          type="number"></el-input>
                                            </template>
                                        </el-table-column>
                                        <el-table-column label="总价（元）">
                                            <template slot-scope="scope">
                                                <el-input size="small" @change="calculateTheTotalCost"
                                                          v-model="scope.row.total_price"
                                                          placeholder="请输入" type="number"></el-input>
                                            </template>
                                        </el-table-column>
                                        <el-table-column label="日期">
                                            <template slot-scope="scope">
                                                <el-date-picker size="small" v-model="scope.row.time" type="date"
                                                                format="yyyy-MM-dd"
                                                                value-format="yyyy-MM-dd"
                                                                placeholder="选择日期" style="width: 140px">
                                                </el-date-picker>
                                            </template>
                                        </el-table-column>
                                        <el-table-column label="操作" width="60">
                                            <template slot-scope="scope">
                                                <el-button @click="deletePiciRow(scope.$index)" type="text"
                                                           size="small">
                                                    <img src="../../../public/images/del.png" alt=""/>
                                                </el-button>
                                            </template>
                                        </el-table-column>
                                    </el-table>
                                    <div class="actions">
                                        <el-button @click="addPiciRow">+ 新增</el-button>
                                    </div>
                                </div>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="2">
                                <div class="grid-title">
                                    运输费用
                                </div>
                            </el-col>
                            <el-col :span="18">
                                <div class="grid-input">
                                    <el-input size="small" @change="calculateTheTotalCost" placeholder="请输入运输费用"
                                              type="number"
                                              v-model="batchForm.transport_fee">
                                        <template slot="prepend">
                                            ￥
                                        </template>
                                    </el-input>
                                </div>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="2">
                                <div class="grid-title">
                                    手续费用
                                </div>
                            </el-col>
                            <el-col :span="18">
                                <div class="grid-input">
                                    <el-input size="small" @change="calculateTheTotalCost" placeholder="请输入手续费用"
                                              type="number"
                                              v-model="batchForm.handle_fee">
                                        <template slot="prepend">
                                            ￥
                                        </template>
                                    </el-input>
                                </div>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="2">
                                <div class="grid-title">
                                    其他费用
                                </div>
                            </el-col>
                            <el-col :span="18">
                                <div class="grid-input">
                                    <el-input size="small" @change="calculateTheTotalCost" placeholder="请输入其他费用"
                                              type="number"
                                              v-model="batchForm.other_fee">
                                        <template slot="prepend">
                                            <p>￥</p>
                                        </template>
                                    </el-input>
                                </div>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="2">
                                <div class="grid-title">
                                    备注信息
                                </div>
                            </el-col>
                            <el-col :span="18">
                                <div class="grid-input">
                                    <el-input size="small" placeholder="请输入" type="text" v-model="batchForm.remark">
                                    </el-input>
                                </div>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="2">
                                <div class="grid-title">
                                    总成本
                                </div>
                            </el-col>
                            <el-col :span="18">
                                <div class="grid-input">
                                    <el-input size="small" placeholder="请输入总成本" :disabled="true" type="number"
                                              v-model="batchForm.total_fee">
                                        <template slot="prepend">
                                            ￥
                                        </template>
                                    </el-input>
                                </div>
                            </el-col>
                        </el-row>
                    </div>
                    <div class="control">
                        <div class="itt quxiao" @click="closeDialogPici">
                            取消
                        </div>
                        <div class="itt sure" @click="addBatch">
                            确认
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- 商品管理弹窗 -->
        <!-- <div class="product_management"> -->
        <div v-if="showDialogProductManagement" class="dialog-overlay">
            <div class="dialog-content">
                <div class="dialog-header">
                    商品管理
                    <img @click="closeDialogProductManagement" src="../../../public/images/close.png" alt=""/>
                </div>
                <div class="dialog-body">
                    <el-button type="primary" @click="addProduct">添加进货商品</el-button>
                    <div class="product_management_title">
                        <p>商品名称</p>
                        <p>参考单价</p>
                        <p>操作</p>
                    </div>
                    <div class="product_management_list">
                        <div class="ite" v-for="item in goodsList">
                            <p>{{ item.name }}</p>
                            <p>￥{{ item.price }}</p>
                            <span @click="delGoods(item.id)">删除</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- 添加商品弹窗 -->
        <div v-if="showDialogAddProduct" class="dialog-overlay">
            <div class="dialog-content">
                <div class="dialog-header">
                    添加进货商品
                    <img @click="closeDialogAddProduct" src="../../../public/images/close.png" alt=""/>
                </div>
                <div class="dialog-body">
                    <el-form ref="form" :model="goodsForm" label-width="80px">
                        <el-form-item label="商品名称">
                            <el-input v-model="goodsForm.name" placeholder="如:活羊、羊羔"></el-input>
                        </el-form-item>
                        <el-form-item label="参考单价">
                            <el-input v-model="goodsForm.price" type="number"></el-input>
                        </el-form-item>
                        <el-form-item>
                            <el-button @click="closeDialogAddProduct">取消</el-button>
                            <el-button type="primary" @click="onSubmit">确定</el-button>
                        </el-form-item>
                    </el-form>
                </div>
            </div>
        </div>

        <!-- 经纪人列表 -->
        <el-dialog title="经济人" :visible.sync="showDialogBroker" center>
            <el-button type="primary" @click="showAddBroker(0)">添加</el-button>
            <el-table :data="brokerList">
                <el-table-column property="name" label="姓名"></el-table-column>
                <el-table-column property="phone" label="手机号"></el-table-column>
                <el-table-column
                    label="操作"
                    width="150">
                    <template slot-scope="scope">
                        <el-button @click="showAddBroker(scope.row.id)" type="primary" size="mini">编辑</el-button>
                        <el-button @click="delAddBroker(scope.row.id)" type="danger" size="mini">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </el-dialog>

        <!-- 添加经纪人 -->
        <el-dialog
            title="经济人"
            :visible.sync="showDialogAddBroker"
            width="40%"
            center>
            <el-form :model="addBrokerForm">
                <el-form-item label="名称" label-width="60px">
                    <el-input v-model="addBrokerForm.name" autocomplete="off" placeholder="请输入姓名"></el-input>
                </el-form-item>
                <el-form-item label="电话" label-width="60px">
                    <el-input v-model="addBrokerForm.phone" autocomplete="off" placeholder="可选"></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="closeAddBroker">取 消</el-button>
                <el-button type="primary" @click="sureAddBroker">确 定</el-button>
              </span>
        </el-dialog>

        <!-- 结算第一步 -->
        <el-dialog
            :title="settleData.title"
            :visible.sync="showFirstSettleStatus"
            width="60%">
            <div>
                <el-form ref="form" :model="settleData" label-width="180px">
                    <el-form-item label="结算日期">
                        <el-date-picker
                            v-model="settleData.rangeDate"
                            type="daterange"
                            format="yyyy-MM-dd"
                            value-format="yyyy-MM-dd"
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期">
                        </el-date-picker>
                    </el-form-item>
                    <el-row :gutter="15">
                        <el-col :sm="12">
                            <el-form-item label="羊下水预估数量">
                                <el-input type="number" @input="calculatingSheepOffal" v-model="settleData.num"></el-input>
                            </el-form-item>
                            <el-form-item label="单价">
                                <el-input type="number" @input="calculatingSheepOffal" v-model="settleData.price" :min="0"></el-input>
                            </el-form-item>
                            <el-form-item label="羊下水总额">
                                <el-input type="number" v-model="settleData.amount" :min="0"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :sm="12">
                            <el-form-item label="余活羊数量">
                                <el-input type="number" @input="calculatingLiveSheep" v-model="settleData.sheep_num"></el-input>
                            </el-form-item>
                            <el-form-item label="余活羊单价">
                                <el-input type="number" @input="calculatingLiveSheep" v-model="settleData.sheep_price" :min="0"></el-input>
                            </el-form-item>
                            <el-form-item label="余活羊总额">
                                <el-input type="number" v-model="settleData.sheep_amount" :min="0"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="showFirstSettleStatus = false">取 消</el-button>
                <el-button type="primary" @click="sureFirstSettle">确 定</el-button>
            </span>
        </el-dialog>

        <!-- 结算第二步 -->
        <el-dialog :title="settleData.title" :visible.sync="showSecondSettleStatus" width="70%">
            <el-col style="font-size: 16px;font-weight: 700;">结算预览：</el-col>
            <el-table :data="settleList">
                <el-table-column property="time" label="日期"></el-table-column>
                <el-table-column property="total_income" label="每日收入"></el-table-column>
                <el-table-column property="expend_money" label="每日支出"></el-table-column>
                <el-table-column property="profit" label="利润"></el-table-column>
                <el-table-column label="订单数量">
                    <template slot-scope="scope">
                        <el-button type="text" @click="showSettleOrderDetailStatus(scope.row.time)">查看({{ scope.row.list.length }})</el-button>
                    </template>
                </el-table-column>
                <el-table-column label="每日宰余">
                    <template slot-scope="scope">
                        <div>宰：{{ scope.row.today.today }}</div>
                        <div>余：{{ scope.row.today.surplus }}</div>
                    </template>
                </el-table-column>
            </el-table>
            <el-descriptions title="羊下水预估收入：" style="margin-top: 20px;">
                <el-descriptions-item label="数量">{{ settleData.num }}</el-descriptions-item>
                <el-descriptions-item label="单价">{{ settleData.price }}</el-descriptions-item>
                <el-descriptions-item label="总额">{{ settleData.amount }}</el-descriptions-item>
            </el-descriptions>
            <el-descriptions title="余活羊收入：" style="margin-top: 20px;">
                <el-descriptions-item label="数量">{{ settleData.sheep_num }}</el-descriptions-item>
                <el-descriptions-item label="单价">{{ settleData.sheep_price }}</el-descriptions-item>
                <el-descriptions-item label="总额">{{ settleData.sheep_amount }}</el-descriptions-item>
            </el-descriptions>
            <el-descriptions title="批次费用：" style="margin-top: 20px;">
                <el-descriptions-item label="运输费用">{{ settleBatch.transport_fee }}</el-descriptions-item>
                <el-descriptions-item label="手续费用">{{ settleBatch.handle_fee }}</el-descriptions-item>
                <el-descriptions-item label="其他费用">{{ settleBatch.other_fee }}</el-descriptions-item>
                <el-descriptions-item label="总成本">{{ settleBatch.total_fee }}</el-descriptions-item>
            </el-descriptions>
            <el-descriptions title="统计汇总：" style="margin-top: 20px;">
                <el-descriptions-item label="总收入">{{ totalIncome }}</el-descriptions-item>
                <el-descriptions-item label="费用总和">{{ totalExpendMoney }}</el-descriptions-item>
                <el-descriptions-item label="批次利润">{{ totalIncome - totalExpendMoney }}</el-descriptions-item>
            </el-descriptions>
            <span slot="footer" class="dialog-footer">
                <el-button type="info" @click="showSecondSettleStatus = false">取 消</el-button>
                <el-button type="success" @click="sureSettle">确认结算</el-button>
            </span>
        </el-dialog>
        <!-- 结算第二步订单详情 -->
        <el-dialog title="订单" :visible.sync="settleOrderDetailStatus" width="60%">
            <el-table :data="settleOrderDetailList">
                <el-table-column property="time" label="日期"></el-table-column>
                <el-table-column property="customer_name" label="姓名"></el-table-column>
                <el-table-column property="product_name" label="商品"></el-table-column>
                <el-table-column property="number" label="数量"></el-table-column>
                <el-table-column property="price" label="单价"></el-table-column>
                <el-table-column property="total_fee" label="总金额">
                    <template slot-scope="scope">
                        <span v-if="scope.row.is_offal == 1">¥{{ scope.row.total_fee }}</span>
                        <del v-if="scope.row.is_offal == 2" style="color: red;">¥{{ scope.row.total_fee }}</del>
                    </template>
                </el-table-column>
            </el-table>
            <span slot="footer" class="dialog-footer">
                <el-button type="info" @click="settleOrderDetailStatus = false">取 消</el-button>
            </span>
        </el-dialog>

        <!-- 结算后的查看 -->
        <!-- 批次结算预览弹窗 -->
        <div v-if="settleStatus" class="dialog-overlay">
            <div class="dialog-content">
                <div class="dialog-header">
                    批次结算查看
                    <img @click="closeShowSettleInfo" src="../../../public/images/close.png" alt=""/>
                </div>
                <div class="dialog-body">
                    <div class="yulan_title">
                        <div class="left">
                            {{ previewBatch.batch_name }}
                        </div>
                        <div class="right">
                            结算日期：{{ previewBatch.settle_start }}至{{ previewBatch.settle_end }}
                        </div>
                    </div>
                    <div class="jiesuan_money_box">
                        <div class="itt">
                            <div class="tt">
                                总收入
                                <img src="../../../public/images/js1.png" alt=""/>
                            </div>
                            <div class="bb">
                                {{ previewBatch.total_income }}
                            </div>
                        </div>
                        <div class="itt">
                            <div class="tt">
                                费用总和
                                <img src="../../../public/images/js2.png" alt=""/>
                            </div>
                            <div class="bb">
                                {{ previewBatch.total_expend }}
                            </div>
                        </div>
                        <div class="itt">
                            <div class="tt">
                                批次利润
                                <img src="../../../public/images/js3.png" alt=""/>
                            </div>
                            <div class="bb">
                                {{ previewBatch.total_profit }}
                            </div>
                        </div>
                    </div>
                    <div class="yulan_title">
                        <div class="left">
                            订单明细
                        </div>
                    </div>
                    <div class="product_mingxi">
                        <div class="tt">
                            <p>日期</p>
                            <p>每日收入</p>
                            <p>每日支出</p>
                            <p>利润</p>
                            <p>订单数量</p>
                            <p>操作</p>
                        </div>
                        <div class="bb" v-for="(item, key) in previewSettleList">
                            <p>{{ item.time }}</p>
                            <p>¥{{ item.total_income }}</p>
                            <p>¥{{ item.expend_money }}</p>
                            <p>¥{{ item.profit }}</p>
                            <p>{{ item.list.length }}</p>
                            <p>
                                <el-link @click="previewOrderDetail(key)" type="primary">查看详情</el-link>
                            </p>
                        </div>
                    </div>
                    <div class="yulan_title">
                        <div class="left">
                            羊下水预估收入
                        </div>
                    </div>
                    <div class="chengben_mingxi">
                        <div class="itte">
                            数量
                            <p>¥{{ previewBatch.offal_num }}</p>
                        </div>
                        <div class="itte">
                            单价
                            <p>¥{{ previewBatch.offal_price }}</p>
                        </div>
                        <div class="itte">
                            总额
                            <span>¥{{ previewBatch.offal_amount }}</span>
                        </div>
                    </div>
                    <div class="yulan_title">
                        <div class="left">
                            余活羊收入
                        </div>
                    </div>
                    <div class="chengben_mingxi">
                        <div class="itte">
                            数量
                            <p>¥{{ previewBatch.sheep_num }}</p>
                        </div>
                        <div class="itte">
                            单价
                            <p>¥{{ previewBatch.sheep_price }}</p>
                        </div>
                        <div class="itte">
                            总额
                            <span>¥{{ previewBatch.sheep_amount }}</span>
                        </div>
                    </div>
                    <div class="yulan_title">
                        <div class="left">
                            批次成本
                        </div>
                    </div>
                    <div class="chengben_mingxi">
                        <div class="itte">
                            运输费用
                            <p>¥{{ previewBatch.transport_fee }}</p>
                        </div>
                        <div class="itte">
                            手续费用
                            <p>¥{{ previewBatch.handle_fee }}</p>
                        </div>
                        <div class="itte">
                            其他费用
                            <p>{{ previewBatch.other_fee }}</p>
                        </div>
                        <div class="itte">
                            总成本
                            <span>¥{{ previewBatch.total_fee }}</span>
                        </div>
                    </div>

                    <div class="control">
                        <div class="itt quxiao" @click="closeShowSettleInfo">
                            关闭
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
export default {
    data() {
        return {
            isLoading: false, // 是否正在加载
            hasMore: true, // 是否还有更多数据
            // 批次列表
            batchList: [],
            current_page: 0, // 当前页
            last_page: 0, // 总页数
            total: 0, // 总条数
            //新建批次-商品选择
            showDialogPici: false,
            batchForm: {
                car_num: '',
                broker_id: '',
                only: '',
                money: '',
                sell_date: '',
                paid: '',
                is_settlement: '1',
                batch_name: '',
                transport_fee: '',
                handle_fee: '',
                other_fee: '',
                total_fee: '',
                remark: '',
            },
            tableDataProduct: [{
                id: 0,
                goods_id: '',
                name: '',
                number: '',
                weight: '',
                price: '',
                total_price: '',
                time: '',
            }],
            isSendBatch: true,
            //结算
            showDialogJieSuan: false,
            jiesuan_name: "903车，赵亮拉205只，352500元已打款清账，1月18日卖",
            jiesuan_day: "",
            //结算日期
            jiesuan_date: "",
            //批次结算预览
            showDialogYuLan: false,
            //商品管理
            goodsList: [],
            showDialogProductManagement: false,
            //添加商品
            showDialogAddProduct: false,
            goodsForm: {
                name: '',
                price: ''
            },
            isSendGoods: true,
            // 经纪人
            showDialogBroker: false,
            brokerList: [],
            showDialogAddBroker: false,
            addBrokerForm: {},
            // 结算
            settleData: {
                id: 0,
                title: '',
                rangeDate: '',
                num: '',
                price: '',
                amount: '',
                sheep_num: '',
                sheep_price: '',
                sheep_amount: '',
            },
            showFirstSettleStatus: false,
            showSecondSettleStatus: false,
            settleList: [],
            totalIncome: '',
            totalExpendMoney: '',
            settleBatch: {},
            settleOrderDetailStatus: false,
            settleOrderDetailList: [],
            // 结算
            settleStatus: false,
            previewSettleList: [],
            previewBatch: [],
        }
    },
    mounted() {
        this.getBatchList();
        this.showBrokerList(0);
        // 添加滚动事件监听器
        this.$nextTick(() => {
            this.addScrollListener();
        });
    },
    destroyed() {
        // 清除滚动事件监听器
        window.removeEventListener('scroll', this.handleScroll);
    },
    methods: {
        //下拉加载
        // 添加滚动事件监听器
        addScrollListener() {
            window.addEventListener('scroll', this.handleScroll, {
                passive: true
            });
        },

        // 处理滚动事件
        handleScroll() {
            if (this.isLoading || !this.hasMore) return;

            // 计算滚动位置
            const scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
            const windowHeight = window.innerHeight;
            const documentHeight = Math.max(
                document.body.scrollHeight,
                document.body.offsetHeight,
                document.documentElement.clientHeight,
                document.documentElement.scrollHeight,
                document.documentElement.offsetHeight
            );

            // 当滚动到底部附近时加载更多
            if (scrollTop + windowHeight >= documentHeight - 100) {
                this.loadMore();
            }
        },

        // 加载更多数据
        loadMore() {
            if (!this.isLoading && this.hasMore) {
                this.getBatchList();
            }
        },

        getCurrentDate() {
            const today = new Date();
            const year = today.getFullYear();
            const month = String(today.getMonth() + 1).padStart(2, '0'); // 月份是从0开始的
            const day = String(today.getDate()).padStart(2, '0');
            return `${year}-${month}-${day}`;
        },
        //返回首页
        backToindex() {
            this.$router.push({
                path: '/',
            })
        },


        // 获取批次
        async getBatchList() {
            var page = this.current_page + 1;
            if (this.last_page > 0) {
                if (page > this.last_page) {
                    this.hasMore = false;
                    return false;
                }
            }

            if (this.isLoading) return;
            this.isLoading = true;

            try {
                const loading = this.$loading({
                    lock: true,
                    text: '',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });

                const res = await this.$http.post('/batch/getBatchList', {
                    page: page,
                });

                loading.close();
                this.isLoading = false;

                if (res.data.code == 0) {
                    this.current_page = res.data.data.current_page;
                    this.last_page = res.data.data.last_page;
                    this.total = res.data.data.total;

                    const batchList = this.batchList.concat(res.data.data.data);
                    this.batchList = batchList;

                    // 检查是否还有更多数据
                    if (page >= this.last_page) {
                        this.hasMore = false;
                    }
                } else {
                    this.$message({
                        type: 'error',
                        message: res.data.msg
                    });
                    this.isLoading = false;
                }
            } catch (error) {
                this.isLoading = false;
                this.$message({
                    type: 'error',
                    message: '网络错误'
                });
            }
        },

        // 获取批次
        // getBatchList() {
        //     var page = this.current_page + 1;
        //     if (this.last_page > 0) {
        //         if (page > this.last_page) {
        //             return false;
        //         }
        //     }
        //     const loading = this.$loading({
        //         lock: true,
        //         text: '',
        //         spinner: 'el-icon-loading',
        //         background: 'rgba(0, 0, 0, 0.7)'
        //     });
        //     this.$http.post('/batch/getBatchList', {
        //         page: page,
        //     }).then(res => {
        //         loading.close();
        //         if (res.data.code == 0) {
        //             this.current_page = res.data.data.current_page;
        //             this.last_page = res.data.data.last_page;
        //             this.total = res.data.data.total;
        //             var batchList = this.batchList.concat(res.data.data.data);
        //             this.batchList = batchList;
        //         } else {
        //             this.$message({
        //                 type: 'error',
        //                 message: res.data.msg
        //             })
        //         }
        //     });
        // },
        // 置顶切换
        setTop(id) {
            const loading = this.$loading({
                lock: true,
                text: '',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            this.$http.post('/batch/setTop', {
                id: id
            }).then(res => {
                loading.close();
                if (res.data.code == 0) {
                    this.batchList = [];
                    this.current_page = 0; // 当前页
                    this.last_page = 0; // 总页数
                    this.total = 0; // 总条数
                    this.getBatchList();
                    this.$message({
                        type: 'success',
                        message: '操作成功!'
                    });
                } else {
                    this.$message({
                        type: 'error',
                        message: res.data.msg
                    })
                }
            });
        },
        // 删除批次
        delBatch(id) {
            this.$confirm('此操作将删除该数据, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                const loading = this.$loading({
                    lock: true,
                    text: '',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                this.$http.post('/batch/delete', {
                    id: id
                }).then(res => {
                    loading.close();
                    if (res.data.code == 0) {
                        this.$message({
                            type: 'success',
                            message: '删除成功!'
                        });
                        this.batchList = [];
                        this.current_page = 0; // 当前页
                        this.last_page = 0; // 总页数
                        this.total = 0; // 总条数
                        this.getBatchList();
                    } else {
                        this.$message({
                            type: 'error',
                            message: res.data.msg
                        })
                    }
                });
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消删除'
                });
            });
        },
        // 新建/编辑 批次弹窗
        addPici(id) {
            const loading = this.$loading({
                lock: true,
                text: '',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            this.$http.get('/goods/getGoodsList').then(res => {
                if (res.data.code == 0) {
                    this.goodsList = res.data.data;
                    if (id <= 0) {
                        loading.close();
                        this.batchForm = {
                            id: 0,
                            car_num: '',
                            broker_id: '',
                            only: '',
                            money: '',
                            sell_date: '',
                            paid: '',
                            is_settlement: '1',
                            batch_name: '',
                            transport_fee: '',
                            handle_fee: '',
                            other_fee: '',
                            total_fee: '',
                            remark: '',
                        };
                        this.tableDataProduct = [{
                            id: 0,
                            goods_id: '',
                            name: '',
                            number: '',
                            weight: '',
                            price: '',
                            total_price: '',
                            time: '',
                        }];
                        this.showDialogPici = true;
                        return false;
                    }
                    // 处理编辑
                    this.$http.post('/batch/getBatchInfo', {
                        id: id
                    }).then(res => {
                        loading.close();
                        if (res.data.code == 0) {
                            this.batchForm = {
                                id: res.data.data.id,
                                car_num: res.data.data.car_num,
                                broker_id: res.data.data.broker_id,
                                only: res.data.data.only,
                                money: res.data.data.money,
                                sell_date: res.data.data.sell_date,
                                paid: res.data.data.paid,
                                is_settlement: res.data.data.is_settlement + '',
                                batch_name: res.data.data.batch_name,
                                transport_fee: res.data.data.transport_fee,
                                handle_fee: res.data.data.handle_fee,
                                other_fee: res.data.data.other_fee,
                                total_fee: res.data.data.total_fee,
                                remark: res.data.data.remark,
                            };
                            this.tableDataProduct = res.data.data.batch_goods;
                            this.showDialogPici = true;
                        } else {
                            this.$message({
                                type: 'error',
                                message: res.data.msg
                            })
                        }
                    });
                } else {
                    loading.close();
                    this.$message({
                        type: 'error',
                        message: res.data.msg
                    })
                }
            });
        },
        // 切换选择商品
        changeSelectGoods(index) {
            var goods = {};
            for (var i = 0; i < this.goodsList.length; i++) {
                if (this.goodsList[i].id == this.tableDataProduct[index].goods_id) {
                    goods = this.goodsList[i];
                }
            }
            this.tableDataProduct[index].price = goods.price;
            this.tableDataProduct[index].name = goods.name;
            this.tableDataProduct[index].time = this.getCurrentDate();
            this.changeGoodsWeigth(index)
        },
        // 改变重量和单价
        changeGoodsWeigth(index) {
            this.tableDataProduct[index].total_price = parseInt(this.tableDataProduct[index].price * (+this.tableDataProduct[
                index].weight), 10);
            this.calculateTheTotalCost();
        },
        // 计算总成本
        calculateTheTotalCost() {
            var total_fee = 0;
            for (var i = 0; i < this.tableDataProduct.length; i++) {
                total_fee += (+this.tableDataProduct[i].total_price);
            }
            total_fee += (+this.batchForm.transport_fee) + (+this.batchForm.handle_fee) + (+this.batchForm
                .other_fee);
            this.batchForm.total_fee = total_fee;
        },

        closeDialogPici() {
            this.showDialogPici = false;
        },
        // 添加批次
        addBatch() {
            if (this.batchForm.car_num == '') {
                this.$message({
                    type: 'error',
                    message: '请输入批次信息'
                })
            }
            if (this.isSendBatch) {
                const loading = this.$loading({
                    lock: true,
                    text: '',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                this.isSendBatch = false;
                this.batchForm.goods_list = this.tableDataProduct;
                this.$http.post('/batch/addBatch', this.batchForm).then(res => {
                    loading.close();
                    this.isSendBatch = true;
                    if (res.data.code == 0) {
                        this.$message({
                            message: "操作成功",
                            type: "success",
                        });
                        // this.productManagement();
                        this.initBatchForm();
                        this.closeDialogPici();
                        location.reload();
                    } else {
                        this.$message({
                            type: 'error',
                            message: res.data.msg
                        })
                    }
                });
            }
        },
        // 初始化批次数据
        initBatchForm() {
            this.batchForm = {
                car_num: '',
                broker_id: '',
                only: '',
                money: '',
                sell_date: '',
                paid: '',
                is_settlement: '1',
                batch_name: '',
                transport_fee: '',
                handle_fee: '',
                other_fee: '',
                total_fee: '',
                remark: '',
            };
            this.tableDataProduct = [{
                id: 0,
                goods_id: '',
                name: '',
                number: '',
                weight: '',
                price: '',
                total_price: '',
                time: '',
            }];
        },
        //增加行
        addPiciRow() {
            this.tableDataProduct.push({
                id: 0,
                goods_id: '',
                number: '',
                weight: '',
                price: '',
                total_price: '',
                time: '',
            });
        },
        //删除行
        deletePiciRow(index) {
            if (this.tableDataProduct.length > 1) {
                this.tableDataProduct.splice(index, 1);
            } else {
                this.$message.warning('至少保留一行数据');
            }
        },
        // 结算弹窗
        jieSuan() {
            this.showDialogJieSuan = true;
        },
        closeDialogJieSuan() {
            this.showDialogJieSuan = false;
        },
        // 批次结算预览弹窗
        yuLan() {
            this.showDialogJieSuan = false;
            this.showDialogYuLan = true;
        },
        closeDialogYuLan() {
            this.showDialogYuLan = false;
        },

        // 商品管理弹窗
        productManagement() {
            const loading = this.$loading({
                lock: true,
                text: '',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            this.$http.get('/goods/getGoodsList').then(res => {
                loading.close();
                if (res.data.code == 0) {
                    this.goodsList = res.data.data;
                    this.showDialogProductManagement = true;
                } else {
                    this.$message({
                        type: 'error',
                        message: res.data.msg
                    })
                }
            });

        },
        closeDialogProductManagement() {
            this.showDialogProductManagement = false;
        },

        // 添加商品弹窗
        addProduct() {
            this.showDialogAddProduct = true;
        },
        closeDialogAddProduct() {
            this.showDialogAddProduct = false;
        },
        delGoods(id) {
            this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                const loading = this.$loading({
                    lock: true,
                    text: '',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                this.$http.post('/goods/reallyDelete', {
                    id: id,
                }).then(res => {
                    loading.close();
                    if (res.data.code == 0) {
                        this.$message({
                            message: "操作成功",
                            type: "success",
                        });
                        this.productManagement();
                    } else {
                        this.$message({
                            type: 'error',
                            message: res.data.msg
                        })
                    }
                });
            }).catch(() => {

            });

        },

        // 添加商品提交
        onSubmit() {
            if (this.goodsForm.name == '') {
                this.$message({
                    message: "请输入商品名称",
                    type: "warning",
                });
            }
            if (this.goodsForm.price < 0) {
                this.$message({
                    message: "请输入参考单价",
                    type: "warning",
                });
            }
            if (this.isSendGoods) {
                const loading = this.$loading({
                    lock: true,
                    text: '',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                this.isSendGoods = false;
                this.$http.post('/goods/edit', {
                    name: this.goodsForm.name,
                    price: this.goodsForm.price
                }).then(res => {
                    loading.close();
                    this.isSendGoods = true;
                    if (res.data.code == 0) {
                        this.$message({
                            message: "操作成功",
                            type: "success",
                        });
                        this.productManagement();
                        this.showDialogAddProduct = false;
                    } else {
                        this.$message({
                            type: 'error',
                            message: res.data.msg
                        })
                    }
                });
            }
        },

        // 展示经纪人列表
        showBrokerList(isShow = 1) {
            var loading;
            if (isShow == 1) {
                loading = this.$loading({
                    lock: true,
                    text: '',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
            }
            this.$http.post('/broker/getBrokerList').then(res => {
                if (isShow == 1) {
                    loading.close();
                }
                if (res.data.code == 0) {
                    this.brokerList = res.data.data;
                    if (isShow == 1) {
                        this.showDialogBroker = true;
                    }
                } else {
                    this.$message({
                        type: 'error',
                        message: res.data.msg
                    })
                }
            });
        },
        // 展示添加编辑经纪人
        showAddBroker(id = 0) {
            if (id <= 0) {
                this.addBrokerForm = {
                    id: 0,
                    name: '',
                    phone: ''
                };
                this.showDialogAddBroker = true;
                return false;
            }
            var loading = this.$loading({
                lock: true,
                text: '',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            this.$http.post('/broker/getBrokerInfo', {id: id}).then(res => {
                loading.close();
                if (res.data.code == 0) {
                    this.addBrokerForm = res.data.data;
                    this.showDialogAddBroker = true;
                } else {
                    this.$message({
                        type: 'error',
                        message: res.data.msg
                    })
                }
            });
        },
        closeAddBroker() {
            this.showDialogAddBroker = false;
        },
        sureAddBroker() {
            if (this.addBrokerForm.name == '') {
                this.$message({
                    type: 'error',
                    message: '请输入姓名'
                })
                return false;
            }
            var loading = this.$loading({
                lock: true,
                text: '',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            this.$http.post('/broker/edit', this.addBrokerForm).then(res => {
                loading.close();
                if (res.data.code == 0) {
                    this.closeAddBroker();
                    this.showBrokerList(1);
                } else {
                    this.$message({
                        type: 'error',
                        message: res.data.msg
                    })
                }
            });
        },
        delAddBroker(id = 0) {
            if (id <= 0) {
                this.$message({
                    type: 'error',
                    message: '参数有误'
                })
                return false;
            }
            this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                const loading = this.$loading({
                    lock: true,
                    text: '',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                this.$http.post('/broker/delete', {
                    id: id,
                }).then(res => {
                    loading.close();
                    if (res.data.code == 0) {
                        this.$message({
                            message: "操作成功",
                            type: "success",
                        });
                        this.showBrokerList(1);
                    } else {
                        this.$message({
                            type: 'error',
                            message: res.data.msg
                        })
                    }
                });
            }).catch(() => {

            });
        },

        // 开始结算
        startSettle(item){
            this.settleData.id = item.id;
            this.settleData.title = item.batch_name;
            this.settleData.rangeDate = '';
            this.settleData.num = '';
            this.settleData.price = '';
            this.settleData.amount = '';
            this.settleData.sheep_num = '';
            this.settleData.sheep_price = '';
            this.settleData.sheep_amount = '';
            this.showFirstSettleStatus = true;
        },
        calculatingSheepOffal(){
            this.settleData.amount = (+this.settleData.num) * (+this.settleData.price);
        },
        calculatingLiveSheep(){
            this.settleData.sheep_amount = (+this.settleData.sheep_num) * (+this.settleData.sheep_price);
        },
        sureFirstSettle(){
            if(this.settleData.rangeDate == ''){
                this.$message({
                    type: 'error',
                    message: '请选择日期'
                })
                return false;
            }
            // 待处理第二步 todo
            const loading = this.$loading({
                lock: true,
                text: '',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            this.$http.post('/batch/getSettleData', this.settleData).then(res => {
                loading.close();
                if (res.data.code == 0) {
                    var totalIncome = 0;
                    var totalExpendMoney = 0;
                    for (var i=0; i<res.data.data.settleList.length; i++) {
                        // 计算每日收入
                        var income = 0;
                        for (var j=0; j<res.data.data.settleList[i].list.length; j++) {
                            if(res.data.data.settleList[i].list[j].is_offal == 1){
                                income += (+res.data.data.settleList[i].list[j].total_fee);
                            }
                        }
                        res.data.data.settleList[i].total_income = income;
                        res.data.data.settleList[i].profit = income - (+res.data.data.settleList[i].expend_money);
                        totalIncome += income;
                        totalExpendMoney += (+res.data.data.settleList[i].expend_money);
                    }
                    totalIncome += (+this.settleData.amount) + (+this.settleData.sheep_amount); // 羊下水收入 + 余活羊
                    this.totalIncome = totalIncome; // 总收入 = 每日卖出 + 羊下水收入 + 余活羊
                    this.totalExpendMoney = totalExpendMoney + (+res.data.data.batch.total_fee); // 费用总和 = 每日支出总和 + 批次成本和
                    this.settleList = res.data.data.settleList;
                    this.settleBatch = res.data.data.batch;
                    this.showFirstSettleStatus = false;
                    this.showSecondSettleStatus = true;
                } else {
                    this.$message({
                        type: 'error',
                        message: res.data.msg
                    })
                }
            });
        },
        // 结算订单展示
        showSettleOrderDetailStatus(time = ''){
            if(time == ''){
                return false;
            }
            const loading = this.$loading({
                lock: true,
                text: '',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            this.$http.post('/batch/getSettleOrderDetailList', {time: time}).then(res => {
                loading.close();
                if (res.data.code == 0) {
                    this.settleOrderDetailList = res.data.data;
                    this.settleOrderDetailStatus = true;
                } else {
                    this.$message({
                        type: 'error',
                        message: res.data.msg
                    })
                }
            });
        },

        // 确认结算
        sureSettle(){
            this.$confirm('结算后将无法撤销, 是否继续?', '提示', {
                "confirmButtonText": '确定',
                "cancelButtonText": '取消',
                "type": 'warning'
            }).then(() => {
                const loading = this.$loading({
                    lock: true,
                    text: '',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                this.$http.post('/batch/settle', this.settleData).then(res => {
                    loading.close();
                    if (res.data.code == 0) {
                        this.$message({
                            message: "结算成功",
                            type: "success",
                            duration: 1000,
                            onClose: () => {
                                this.showSecondSettleStatus = false;
                                location.reload();
                            }
                        });
                    } else {
                        this.$message({
                            type: 'error',
                            message: res.data.msg
                        })
                    }
                });
            }).catch(() => {

            });
        },

        // 结算查看
        showSettleInfo(id){
            const loading = this.$loading({
                lock: true,
                text: '',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            this.$http.post('/batch/previewSettleInfo', {id: id}).then(res => {
                loading.close();
                if (res.data.code == 0) {
                    for (var i=0; i<res.data.data.settleList.length; i++) {
                        // 计算每日收入
                        var income = 0;
                        for (var j=0; j<res.data.data.settleList[i].list.length; j++) {
                            if(res.data.data.settleList[i].list[j].is_offal == 1){
                                income += (+res.data.data.settleList[i].list[j].total_fee);
                            }
                        }
                        res.data.data.settleList[i].total_income = income;
                        res.data.data.settleList[i].profit = income - (+res.data.data.settleList[i].expend_money);
                    }
                    this.previewSettleList = res.data.data.settleList;
                    this.previewBatch = res.data.data.batch;
                    this.settleStatus = true;
                } else {
                    this.$message({
                        type: 'error',
                        message: res.data.msg
                    })
                }
            });
        },
        closeShowSettleInfo(){
            this.settleStatus = false;
        },
        previewOrderDetail(key){
            this.settleOrderDetailList = this.previewSettleList[key].list;
            this.settleOrderDetailStatus = true;
        },
    }
}
</script>

<style lang="less" scoped>
.main {
    padding: 0 20px;
    box-sizing: border-box;
    margin-top: 20px;

    .top_title {
        display: flex;
        align-items: center;
        justify-content: space-between;
        background: #FFFFFF;
        border-radius: 8px 8px 8px 8px;
        padding: 20px;
        margin-bottom: 20px;
        box-sizing: border-box;

        .left {
            padding-left: 8px;
            font-family: PingFang SC, PingFang SC;
            font-weight: 500;
            font-size: 18px;
            color: #36363A;
            line-height: 28px;
            position: relative;
        }

        .left::after {
            content: '';
            display: block;
            width: 4px;
            height: 17px;
            background: #3F72FF;
            border-radius: 12px 12px 12px 12px;
            position: absolute;
            left: 0;
            top: 6px;
        }

        .right {
            display: flex;
            align-items: center;

            .itt {
                display: flex;
                align-items: center;
                cursor: pointer;

                img {
                    display: block;
                    width: 16px;
                    height: 16px;
                    margin-right: 4px;
                }

                p {
                    font-family: PingFang SC, PingFang SC;
                    font-weight: 400;
                    font-size: 16px;
                    color: #3F72FF;
                }
            }

            .itt:first-child {
                margin-right: 20px;
            }
        }
    }

    .pici_list {
        .pici_item {
            background: #FFFFFF;
            border-radius: 8px 8px 8px 8px;
            padding: 20px;
            padding-bottom: 0;
            margin-bottom: 20px;

            .pici_item_top {
                display: flex;
                align-items: center;
                justify-content: space-between;
                border-bottom: 1px solid #F0F0F0;

                .left {
                    display: flex;
                    align-items: center;

                    .ll {
                        font-family: PingFang SC, PingFang SC;
                        font-weight: 500;
                        font-size: 16px;
                        color: #36363A;
                        line-height: 38px;
                        flex: 1;
                        overflow: hidden;
                        white-space: nowrap;
                        text-overflow: ellipsis;
                    }

                    .rr {
                        span {
                            font-family: PingFang SC, PingFang SC;
                            font-weight: 400;
                            font-size: 12px;
                            border-radius: 4px 4px 4px 4px;
                            margin-left: 4px;
                            padding: 2px 4px;
                        }

                        .zd {
                            color: #FFFFFF;
                            background: #FF7700;
                        }

                        .yjs {
                            color: #52C41A;
                            background: #F2FFEC;
                        }
                    }
                }

                .right {
                    display: flex;
                    align-items: center;

                    .itt {
                        display: flex;
                        align-items: center;
                        margin-left: 16px;
                        color: #333;
                        cursor: pointer;

                        img {
                            display: block;
                            width: 16px;
                            height: 16px;
                            margin-right: 4px;
                        }

                        p {
                            font-family: PingFang SC, PingFang SC;
                            font-weight: 400;
                            font-size: 14px;
                            line-height: 22px;
                        }
                    }

                    .itt.zd_qx {
                        color: #FF7700;
                    }

                    .itt.exit {
                        color: #3F72FF;
                    }

                    .itt.js {
                        color: #FF7700;
                    }

                    .itt.js_look {
                        color: #4A5676;
                    }

                    .itt.del {
                        color: #FF4D4F;
                    }

                    .itt.zd {
                        color: #389F0D;
                    }
                }
            }

            .pici_item_fei {
                .pici_item_fei_tit {
                    font-family: HarmonyOS Sans SC, HarmonyOS Sans SC;
                    font-weight: 400;
                    font-size: 14px;
                    color: #36363A;
                    line-height: 22px;
                    padding: 12px 0 8px 0;
                }

                .pici_item_fei_box {
                    padding: 12px;
                    background: #F5F6FC;
                    display: flex;
                    align-items: center;

                    .itt {
                        flex: 1;

                        p {
                            font-family: PingFang SC, PingFang SC;
                            font-weight: 400;
                            font-size: 14px;
                            color: #9B9CA1;
                            line-height: 22px;
                        }

                        h3 {
                            font-family: PingFang SC, PingFang SC;
                            font-weight: 400;
                            font-size: 14px;
                            color: #36363A;
                            line-height: 22px;
                            margin-top: 4px;
                        }
                    }
                }
            }

            .zhedie {
                .zhedie_box {
                    //overflow: hidden;
                    //display: none;
                    //transition: height 0.3s ease-in-out;

                    .zhedie_tit {
                        font-family: HarmonyOS Sans SC, HarmonyOS Sans SC;
                        font-weight: 400;
                        font-size: 14px;
                        color: #36363A;
                        line-height: 22px;
                        padding: 12px 0 8px 0;
                    }

                    .zhedie_con {
                        .zhedie_con_tit {
                            display: flex;
                            align-items: center;
                            background: #F5F6FC;

                            p {
                                flex: 1;
                                font-family: PingFang SC, PingFang SC;
                                font-weight: 400;
                                font-size: 14px;
                                color: #9B9CA1;
                                line-height: 38px;
                                padding: 0 6px;
                                box-sizing: border-box;
                            }
                        }

                        .zhedie_con_body {
                            .itt {
                                display: flex;
                                align-items: center;
                                padding: 12px 0;
                                border-bottom: 1px solid #F0F0F0;

                                p {
                                    flex: 1;
                                    font-family: PingFang SC, PingFang SC;
                                    font-weight: 400;
                                    font-size: 16px;
                                    color: #4A5676;
                                    line-height: 24px;
                                    padding: 0 6px;
                                    box-sizing: border-box;
                                }
                            }
                        }
                    }
                }

                .slide {
                    .tem {
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        font-family: PingFang SC, PingFang SC;
                        font-weight: 400;
                        font-size: 16px;
                        color: #4A5676;
                        line-height: 24px;
                        padding: 8px 0;
                        cursor: pointer;

                        img {
                            display: block;
                            width: 16px;
                            height: 16px;
                            margin-right: 4px;
                        }
                    }
                }

            }

        }
    }
}

.dialog-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 2000;

    .dialog-content {
        background: white;
        border-radius: 8px;
        width: 80%;
        max-width: 90%;
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
        padding: 24px;

        .dialog-header {
            display: flex;
            justify-content: space-between;
            align-items: center;
            font-family: PingFang SC, PingFang SC;
            font-weight: 500;
            font-size: 18px;
            color: #4A5676;
            margin-bottom: 26px;

            img {
                display: block;
                width: 24px;
                height: 24px;
                cursor: pointer;
            }
        }

        .dialog-body {
            .item {
                margin-bottom: 20px;

                .title {
                    display: flex;
                    align-items: center;
                    font-family: PingFang SC, PingFang SC;
                    font-weight: 400;
                    font-size: 16px;
                    color: #36363A;
                    margin-bottom: 12px;

                    span {
                        color: #CB2D18;
                    }
                }

                .con {
                    .el-date-editor.el-input {
                        width: 100%;
                    }
                }
            }

            .el-row {
                margin-top: 20px;
            }

            .grid-title {
                font-family: PingFang SC, PingFang SC;
                font-weight: 400;
                font-size: 16px;
                color: #36363A;
                line-height: 35px;
            }

            .grid-input {
                .el-input {
                    .el-input__prefix {
                        line-height: 35px;
                    }
                }
            }


            .table {
                .el-table tr {
                    background: #F5F6FC !important;
                }

                .el-button {
                    img {
                        display: block;
                        width: 16px;
                        height: 16px;
                    }
                }

                .actions {
                    width: 100%;
                    border-radius: 4px 4px 4px 4px;
                    border: 1px dashed #C1D0FB;
                    text-align: center;
                    margin-top: 8px;

                    .el-button {
                        margin: 0 auto;
                        border: 0;
                        padding: 0;
                        line-height: 40px;
                        height: 40px;
                        width: 100%;
                        display: block;
                        font-family: PingFang SC, PingFang SC;
                        font-weight: 400;
                        font-size: 16px;
                        color: #3F72FF;
                    }
                }

                .submit {
                    margin-top: 30px;
                    width: 100%;
                    border-radius: 60px;
                    line-height: 60px;
                    text-align: center;

                    .el-button {
                        background: #3F72FF;
                        margin: 0 auto;
                        border: 0;
                        padding: 0;
                        line-height: 60px;
                        height: 60px;
                        border-radius: 60px;
                        width: 100%;
                        display: block;
                        font-family: PingFang SC, PingFang SC;
                        font-weight: 500;
                        font-size: 18px;
                        color: #FFFFFF;
                    }
                }
            }

            .control {
                display: flex;
                align-items: center;
                justify-content: flex-end;
                margin-top: 20px;

                .itt {
                    width: 96px;
                    height: 40px;
                    border-radius: 4px 4px 4px 4px;
                    box-sizing: border-box;
                    line-height: 40px;
                    font-family: PingFang SC, PingFang SC;
                    font-weight: 400;
                    font-size: 16px;
                    text-align: center;
                    margin-left: 16px;
                    cursor: pointer;
                }

                .quxiao {
                    border: 1px solid #E5E5E7;
                    color: #36363A;

                }

                .sure {
                    background: #3F72FF;
                    border: 1px solid #3F72FF;
                    color: #FFFFFF;
                }
            }

            .yulan_title {
                display: flex;
                align-items: center;
                justify-content: space-between;
                margin-bottom: 8px;

                .left {
                    flex: 1;
                    box-sizing: border-box;
                    padding-left: 8px;
                    font-family: PingFang SC, PingFang SC;
                    font-weight: 500;
                    font-size: 18px;
                    color: #36363A;
                    line-height: 28px;
                    position: relative;
                }

                .left::after {
                    content: '';
                    display: block;
                    width: 4px;
                    height: 17px;
                    background: #3F72FF;
                    border-radius: 12px 12px 12px 12px;
                    position: absolute;
                    left: 0;
                    top: 6px;
                }

                .right {
                    font-family: PingFang SC, PingFang SC;
                    font-weight: 400;
                    font-size: 14px;
                    color: #9B9CA1;
                    line-height: 22px;
                }
            }

            .jiesuan_money_box {
                display: flex;
                align-items: center;
                justify-content: space-between;
                margin-top: 16px;
                margin-bottom: 20px;

                .itt {
                    flex: 0 0 32%;
                    background: #e8e8e8;
                    border-radius: 8px 8px 8px 8px;
                    padding: 16px;
                    box-sizing: border-box;

                    .tt {
                        display: flex;
                        align-items: center;
                        justify-content: space-between;
                        font-family: PingFang SC, PingFang SC;
                        font-weight: 400;
                        font-size: 14px;
                        color: #4A5676;
                        line-height: 22px;
                        margin-bottom: 4px;

                        img {
                            display: block;
                            width: 20px;
                            height: 20px;
                        }
                    }

                    .bb {
                        font-family: DIN, DIN;
                        font-weight: 500;
                        font-size: 24px;
                        color: #333;
                        line-height: 32px;
                    }
                }

                .itt:first-child {
                    background: #F5F6FC;

                    .bb {
                        color: #3F72FF;
                    }
                }

                .itt:nth-child(2) {
                    background: #FFFBEF;

                    .bb {
                        color: #FFCC00;
                    }
                }

                .itt:last-child {
                    background: #F5FCF5;

                    .bb {
                        color: #389F0D;
                    }
                }
            }

            .product_mingxi {
                margin-bottom: 20px;

                .tt {
                    display: flex;
                    align-items: center;
                    background: #F5F6FC;

                    p {
                        flex: 1;
                        font-family: PingFang SC, PingFang SC;
                        font-weight: 400;
                        font-size: 14px;
                        color: #9B9CA1;
                        line-height: 24px;
                        padding: 12px 0 12px 6px;
                        box-sizing: border-box;
                    }
                }

                .bb {
                    display: flex;
                    align-items: center;
                    border-bottom: 1px solid #F0F0F0;

                    p {
                        flex: 1;
                        font-family: PingFang SC, PingFang SC;
                        font-weight: 400;
                        font-size: 16px;
                        color: #4A5676;
                        line-height: 24px;
                        padding: 12px 0 12px 6px;
                        box-sizing: border-box;

                        span {
                            color: #3F72FF;
                        }
                    }
                }
            }

            .chengben_mingxi {
                display: flex;
                align-items: center;
                background: #F5F6FC;

                .itte {
                    flex: 1;
                    display: flex;
                    flex-direction: column;
                    font-family: PingFang SC, PingFang SC;
                    font-weight: 400;
                    font-size: 14px;
                    color: #9B9CA1;
                    line-height: 22px;
                    padding: 12px;
                    box-sizing: border-box;

                    p {
                        color: #36363A;
                        margin-top: 4px;
                    }

                    span {
                        color: #FF4D4F;
                    }
                }
            }

            .product_management_title {
                display: flex;
                align-items: center;
                border-bottom: 1px solid #F0F0F0;
                margin-top: 20px;

                p {
                    flex: 1;
                    font-family: PingFang SC, PingFang SC;
                    font-weight: 400;
                    font-size: 16px;
                    color: #36363A;
                    line-height: 30px;
                }
            }

            .product_management_list {
                .ite {
                    display: flex;
                    align-items: center;
                    border-bottom: 1px solid #F0F0F0;

                    p {
                        flex: 1;
                        font-family: PingFang SC, PingFang SC;
                        font-weight: 400;
                        font-size: 16px;
                        color: #4A5676;
                        line-height: 40px;
                    }

                    span {
                        flex: 1;
                        font-family: PingFang SC, PingFang SC;
                        font-weight: 400;
                        font-size: 16px;
                        color: #CB2D18;
                        padding-left: 8px;
                        box-sizing: border-box;
                        line-height: 40px;
                    }
                }
            }
            .demo-form-inline{
                .choose-box{
                    display: flex;
                    align-items: center;
                    margin-bottom: 10px;
                    .choose-item{
                        margin-right: 10px;
                        font-size: 14px;
                    }
                }
            }
        }
    }
}
</style>
